(ns ballot-scout-v2-frontend.widget.translations)

(def translations-dict
  {:en {:endonym "English"
        :missing "**MISSING**" ; Fallback for missing resources
        :track-your-ballot "Track Your Ballot"
        :select-language "Select Language"
        :select-election "Select Election"
        :required-field "Required Field"
        :name "Name"
        :name-description "The name that appears on your voter registration"
        :your-name "Your Name"
        :first-name "First Name"
        :last-name "Last Name"
        :address "Address"
        :address-description "The address you requested your ballot be mailed to"
        :address-1-placeholder "Street address or P.O. Box"
        :address-2-placeholder "Apt, Suite, Unit, or Building"
        :ballot-address "Your Ballot Mailing Address"
        :addr-line-1 "Address line 1"
        :addr-line-2 "Address line 2"
        :city "City"
        :state "State"
        :select-state "Select State"
        :zip "Zip Code"
        :yes-receive-notys "Yes, I would like to receive email or text message (SMS) notifications about my ballot’s status."
        :submit "Search"
        :fields-invalid "The field entry highlighted below is not valid. Please correct the entry and resubmit the form."
        :unable-locate-ballot "We're sorry, we weren't able to locate your ballot at this time. Please double-check your information and resubmit the form or try again later."
        :unable-locate-ballot-2 "The information you entered does not match any ballots in our system. Please double-check your information and resubmit the form or try again later."
        :multiple-ballots-found "We found multiple potential matches for the information you entered - please choose the correct information from the list below."
        :ballot-located "Your Ballot Has Been Located"
        :we-found-multiple-elections "We found ballots for multiple elections. "
        :choose-an-election "Please choose one of the following elections for more details."
        :partner-not-found "Partner not found"
        :searching-ellipse "Searching..."
        :i-am "I am:"
        :none-of-the-above "None of the above"
        :search-usage-alttag "Search widget usage instructions"
        :logo-alt-tag "Ballot Scout compass logo"
        :mailbox-error-alttag "Image of a mailbox with a red exclamation point to indicate that something has gone wrong"
        :powered-by [[:span#powered-by "powered by"] [:span#democracy-works "%1"]]
        :footer-questions-call ["Questions? To contact %1, call %2"]
        :call-office ["Call %1 Election Office"]
        :email-office ["Email %1 Election Office"]
        :or-email [" or email %1"]
        :notifications "Notifications"
        :subscribe-me "Subscribe Me"
        :email-address "Email address"
        :phone-number "Phone number"
        :already-signed-up "You have already signed up for %1 notifications."
        :unable-to-process "We were unable to process your %1 subscription, please try again later."
        :youve-subscribed "You've subscribed to notifications via %1"
        :youre-subscribed "You're subscribed"
        :email "email"
        :sms "SMS"
        :send-me-email "Send me email updates"
        :send-me-sms "Send me text message (SMS) updates"
        :check-email "Check your email to confirm subscription"
        :check-texts "Check your texts to confirm subscription"
        :update-email "Update Email"
        :update-phone "Update Phone Number"
        :you-have-been-unsubscribed "You have been unsubscribed"
        :resubscribe "To resubscribe text \"YES\" to %1"
        :election "election"
        :Election "Election"
        :last-updated "Last updated: %1"
        :it-was-last-scanned-in-city-state " It was last scanned in %1, %2. "
        :it-was-last-scanned-usps " It was last scanned by the USPS in %1, %2 on %3"
        ; -- Widget Statuses --
        :not-tracked "Not Tracked"
        :being-prepared "Being Prepared"
        :not-yet-mailed "Not Yet Mailed"
        :mailed-to-voter "Mailed to You"
        :out-for-delivery-to-voter "Out For Delivery to You"
        :in-transit-to-voter "In Transit to You"
        :delivery-scheduled "Delivery Scheduled"
        :mailed-to-office "Mailed to Office"
        :mailed-back-to-office "Mailed Back to Office"
        :in-transit-to-office "In Transit to Office"
        :out-for-delivery-to-office "Out for Delivery to Office"
        :received "Received"
        :received-by-office "Received by Office"
        :received-by-office-accepted "Received by Office - Accepted"
        :received-by-office-flagged "Received by Office - Flagged"
        :returned-to-sender "Returned to Sender"
        ; -- Explanations Messages --
        :unable-to-deliver "The post office was unable to deliver your ballot for some reason. Please contact the election office using the contact details below."
        :unable-to-deliver-2 "The post office was unable to deliver your ballot for some reason. "
        :learn-more-contact-office "To learn more please contact the election office."
        :ballot-accepted-on "Your ballot was accepted by the election office on %1. "
        :issue-with-ballot "There may be an issue with your ballot. "
        :please-contact-office "Please contact your local election office at %1"
        :not-tracked-explanation "Your ballot is not currently tracked. "
        :not-yet-mailed-explanation "Your ballot is being prepared for mailing. "
        :not-yet-mailed-explanation-2 "Your ballot has not been mailed yet. Check back later for updated information or sign up for notifications to stay updated automatically."
        :check-back-soon " Check back soon for updated information."
        :voter-bound-mailed-explanation "Your ballot has been mailed and is on its way to you. "
        :voter-bound-in-transit-explanation "Your ballot is in the mail on its way to you! "
        :voter-bound-delivered-explanation "Based on USPS data, you should expect your ballot to arrive on/about %1. "
        :voter-bound-delivered-explanation-2 "Based on USPS data, you should expect your ballot to arrive to your address on/about %1. "
        :office-bound-mailed-explanation "You've returned your ballot to the post office and it is being sent back to the election office."
        :office-bound-in-transit-explanation "Your ballot is traveling through the mail on its way to the election office. "
        :office-bound-delivered-explanation-on "Your ballot should have been received by the election office on %1. "
        :office-bound-delivered-explanation "Your ballot should have been received by the election office. "
        :they-should-receive-it-by-eod "They should receive it by the end of the day on %1. "
        :if-there-are-problems "If there are problems with your ballot, you will be notified by election officials."
        :vote! "Vote!"
        :vote-instructions "Follow instructions on the ballot and envelope to vote!"
        :continue "Continue"
        :subscribe "Subscribe"
        :unsubscribe "Unsubscribe"
        :you-have-signed-up-to-email-notys "You have successfully signed up to receive ballot tracking notifications via email."
        :sorry! "Sorry!"
        :could-not-verify-email "We could not verify your email."
        :you-have-been-unsubscribed-from-email-notys "You have been unsubscribed from ballot tracking notifications via email."
        :error-processing-unsubcribe "There was an error processing your unsubscribe  request."
        :loading-ellipses "Loading..."
        :thank-you! "Thank you!"
        :thanks-for-voting "Thanks for voting!"
        :learn-more "Learn More"
        :privacy "Privacy"
        :terms "Terms"}
   :de {:endonym "Deutsch"
        :missing "**FEHLT**"
        :track-your-ballot "Wahlzettel verfolgen"
        :select-language "Sprache wählen"
        :select-election "Wahl auswählen"
        :required-field "Erforderliches Feld"
        :name "Name"
        :name-description "Der Name, der in Ihrem Wählerverzeichnis steht"
        :your-name "Ihr Name"
        :first-name "Vorname"
        :last-name "Nachname"
        :address "Adresse"
        :address-description "Die Adresse, an die Sie Ihren Stimmzettel geschickt bekommen haben"
        :address-1-placeholder "Straße oder Postfach"
        :address-2-placeholder "Wohnung, Appartement, Einheit oder Gebäude"
        :ballot-address "Ihre Wahlzettel-Postanschrift"
        :addr-line-1 "Anschrift (Zeile 1)"
        :addr-line-2 "Anschrift (Zeile 2)"
        :city "Ort"
        :state "Staat"
        :select-state "Staat auswählen"
        :zip "Postleitzahl"
        :yes-receive-notys "Ja, ich möchte per E-Mail oder SMS über den Status meines Wahlzettels informiert werden."
        :submit "Suchen"
        :fields-invalid "Die Eingabe im hervorgehobenen Feld ist ungültig. Bitte berichtigen Sie die Eingabe und senden Sie das Formular erneut ab."
        :unable-locate-ballot "Leider konnten wir Ihren Wahlzettel diesmal nicht finden. Bitte prüfen Sie Ihre Angaben und senden Sie das Formular erneut ab oder versuchen Sie es später noch einmal."
        :unable-locate-ballot-2 "Die von Ihnen eingegebenen Informationen stimmen mit keinem Stimmzettel in unserem System überein. Bitte überprüfen Sie Ihre Angaben und senden Sie das Formular erneut ab oder versuchen Sie es später noch einmal."
        :multiple-ballots-found "Wir haben mehrere mögliche Treffer für Ihre Angaben gefunden – bitte wählen Sie die richtigen Informationen aus der Liste unten."
        :ballot-located "Ihr Wahlzettel wurde gefunden"
        :we-found-multiple-elections "Wir haben Wahlzettel für mehrere Wahlen gefunden."
        :choose-an-election "Bitte wählen Sie eine der folgenden Wahlen, um mehr Details anzuzeigen."
        :partner-not-found "Partner nicht gefunden"
        :searching-ellipse "Suche ..."
        :i-am "Ich bin:"
        :none-of-the-above "Nichts davon"
        :search-usage-alttag "Verwendungshinweise für das Suchmenü"
        :logo-alt-tag "Ballot Scout-Kompasslogo"
        :mailbox-error-alttag "Bild eines Briefkastens mit rotem Ausrufezeichen, um anzuzeigen, dass etwas schiefgegangen ist"
        :powered-by [[:span#powered-by "unterstützt von"] [:span#democracy-works "%1"]]
        :footer-questions-call ["Noch Fragen? Um %1 zu kontaktieren, rufen Sie an unter %2"]
        :call-office ["Rufen Sie das %1-Wahlbüro an"]
        :email-office ["E-Mail %1 Wahlbüro"]
        :or-email [" oder E-Mail %1"]
        :notifications "Benachrichtigungen"
        :subscribe-me "Anmelden"
        :email-address "E-Mail-Adresse"
        :phone-number "Rufnummer"
        :already-signed-up "Sie haben sich bereits zu Benachrichtigungen per %1 angemeldet."
        :unable-to-process "Wir konnten Ihre %1-Anmeldung nicht bearbeiten. Bitte versuchen Sie es später noch einmal."
        :youve-subscribed "Sie haben sich zu Benachrichtigungen per %1 angemeldet"
        :youre-subscribed "Sie sind abonniert"
        :email "E-Mail"
        :sms "SMS"
        :send-me-email "E-Mail-Updates senden"
        :send-me-sms "Senden Sie mir Textnachrichten (SMS) Aktualisierungen"
        :check-email "Überprüfen Sie Ihre E-Mail, um Ihr Abonnement zu bestätigen"
        :check-texts "Überprüfen Sie Ihre SMS, um Ihr Abonnement zu bestätigen"
        :update-email "E-Mail aktualisieren"
        :update-phone "Telefonnummer aktualisieren"
        :you-have-been-unsubscribed "Sie wurden abgemeldet"
        :resubscribe "Um sich erneut anzumelden, schreiben Sie \"YES\" an %1"
        :election "Wahl"
        :Election "Wahl"
        :last-updated "Letzte Aktualisierung: %1"
        :it-was-last-scanned-in-city-state " Der Wahlzettel wurde zuletzt %1, %2 gescannt. "
        :it-was-last-scanned-usps "Es wurde zuletzt vom USPS gescannt in %1, %2 am %3"
        :not-tracked "Nicht erfasst"
        :being-prepared "Wird vorbereitet"
        :not-yet-mailed "Noch nicht versandt"
        :mailed-to-voter "An Sie versandt"
        :out-for-delivery-to-voter "In Zustellung an Sie"
        :in-transit-to-voter "Unterwegs zu Ihnen"
        :delivery-scheduled "Zustellung geplant"
        :mailed-to-office "Ans Amt gesendet"
        :mailed-back-to-office "Zurück zum Büro geschickt"
        :in-transit-to-office "Unterwegs zum Büro"
        :out-for-delivery-to-office "In Zustellung ans Büro"
        :received "Empfangen"
        :received-by-office "Vom Amt erhalten"
        :received-by-office-accepted "Vom Amt erhalten - akzeptiert"
        :received-by-office-flagged "Vom Amt erhalten – Markiert"
        :returned-to-sender "Zurück an Absender"
        :unable-to-deliver "Die Post konnte Ihren Wahlzettel aus bestimmten Gründen nicht zustellen. Bitte wenden Sie sich unter den Kontaktdaten unten an das Wahlbüro."
        :unable-to-deliver-2 "Die Post konnte Ihren Stimmzettel aus irgendeinem Grund nicht zustellen. "
        :learn-more-contact-office "Um mehr zu erfahren, wenden Sie sich bitte an das Wahlbüro."
        :ballot-accepted-on "Ihr Wahlzettel wurde am %1 vom Wahlbüro akzeptiert. "
        :issue-with-ballot "Es liegt möglicherweise ein Problem mit Ihrem Wahlzettel vor. "
        :please-contact-office "Bitte wenden Sie sich an Ihr örtliches Wahlbüro unter "
        :not-tracked-explanation "Ihr Wahlzettel wird derzeit nicht erfasst. "
        :not-yet-mailed-explanation "Ihr Wahlzettel wird für den Versand vorbereitet. "
        :not-yet-mailed-explanation-2 "Ihr Stimmzettel wurde noch nicht verschickt. Schauen Sie später noch einmal nach, um aktuelle Informationen zu erhalten, oder melden Sie sich für Benachrichtigungen an, um automatisch auf dem Laufenden zu bleiben."
        :check-back-soon " Achten Sie hier in Kürze auf aktualisierte Informationen."
        :voter-bound-mailed-explanation "Ihr Wahlzettel wurde verschickt und ist auf dem Weg zu Ihnen. "
        :voter-bound-in-transit-explanation "Ihr Wahlzettel ist in der Post und auf dem Weg zu Ihnen! "
        :voter-bound-delivered-explanation "Laut USPS-Daten sollte Ihr Wahlzettel ankommen am/um %1. "
        :voter-bound-delivered-explanation-2 "Aufgrund der Daten des USPS sollten Sie damit rechnen, dass Ihr Stimmzettel am/um %1 an Ihrer Adresse eintrifft. "
        :office-bound-mailed-explanation "Sie haben Ihren Wahlzettel zur Post gebracht und er wird jetzt zurück zum Wahlbüro verschickt."
        :office-bound-in-transit-explanation "Ihr Wahlzettel ist auf dem Postweg und auf dem Weg zum Wahlbüro. "
        :office-bound-delivered-explanation-on "Ihr Wahlzettel sollte am %1 im Wahlbüro eingegangen sein. "
        :office-bound-delivered-explanation "Ihr Wahlzettel sollte im Wahlbüro eingegangen sein. "
        :they-should-receive-it-by-eod "Er sollte bis zum Abend des %1 dort eingehen. "
        :if-there-are-problems "Falls es Probleme mit Ihrem Wahlzettel gibt, werden Sie von Wahlbeauftragten benachrichtigt."
        :vote! "Wählen Sie!"
        :vote-instructions "Folgen Sie den Anweisungen auf dem Stimmzettel und dem Umschlag, um zu wählen!"
        :continue "Weiter"
        :subscribe "Abonnieren"
        :unsubscribe "Abbestellen"
        :you-have-signed-up-to-email-notys "Sie haben sich erfolgreich angemeldet, um Benachrichtigungen über die Stimmabgabe per E-Mail zu erhalten."
        :sorry! "Es tut uns leid!"
        :could-not-verify-email "Wir konnten Ihre E-Mail nicht verifizieren."
        :you-have-been-unsubscribed-from-email-notys "Sie wurden von Stimmzettel-Verfolgung Benachrichtigungen per E-Mail abgemeldet."
        :error-processing-unsubcribe "Es ist ein Fehler bei der Bearbeitung Ihrer Abmeldeanfrage aufgetreten."
        :loading-ellipses "Wird geladen..."
        :thank-you! "Vielen Dank!"
        :thanks-for-voting "Danke fürs Wählen!"
        :learn-more "Mehr erfahren"
        :privacy "Datenschutz"
        :terms "Bedingungen"}
   :ar {:endonym "العربية"
        :missing "**مفقود**"
        :track-your-ballot "تتبع بطاقة تصويتك"
        :select-language "اختر اللغة"
        :select-election "اختر انتخابًا"
        :required-field "معلومات مطلوبة"
        :name "الاسم"
        :name-description "الاسم الذي يظهر في تسجيل الناخب الخاص بك"
        :your-name "اسمك"
        :first-name "الاسم الأول"
        :last-name "الاسم الأخير"
        :address "العنوان"
        :address-description "العنوان الذي طلبت أن تُرسَل إليك بطاقة اقتراعك بريديًّا عليه"
        :address-1-placeholder "عنوان الشارع أو الصندوق البريدي"
        :address-2-placeholder "الشقة، أو الجناح، أو الوحدة، أو المبنى"
        :ballot-address "عنوانك البريدي الخاص ببطاقة التصويت"
        :addr-line-1 "سطر العنوان 1"
        :addr-line-2 "سطر العنوان 2"
        :city "المدينة"
        :state "الولاية"
        :select-state "اختر ولاية"
        :zip "الرمز البريدي"
        :yes-receive-notys
        "نعم، أرغب في تلقي إشعارات عبر البريد الإلكتروني أو الرسائل النصية حول حالة بطاقة تصويتي."
        :submit "بحث"
        :fields-invalid
        "الإدخال المميز بالحقل أدناه ليس صالحًا. يُرجى تصحيح الإدخال وإعادة إرسال النموذج."
        :unable-locate-ballot
        "عذرًا، لم نتمكن من تحديد مكان بطاقة تصويتك في هذا الوقت. يُرجى إعادة التحقق من معلوماتك وإعادة تقديم النموذج أو المحاولة مرة أخرى لاحقًا."
        :unable-locate-ballot-2 "المعلومات التي أدخلتها لا تتوافق مع أي بطاقة اقتراع على النظام لدينا. يُرجى إعادة مراجعة معلوماتك وإعادة تقديم الطلب أو المحاولة مجددًا في وقت لاحق."
        :multiple-ballots-found
        "لقد وجدنا العديد من حالات التطابق المحتملة للمعلومات التي أدخلتها - يرجى اختيار المعلومات الصحيحة من القائمة أدناه."
        :ballot-located "تم تحديد مكان بطاقة تصويتك"
        :we-found-multiple-elections "وجدنا بطاقات تصويت لانتخابات متعددة."
        :choose-an-election
        "يُرجى اختيار خيار واحد من الخيارات التالية للاطلاع على مزيد من التفاصيل."
        :partner-not-found "لم يتم العثور على شريك"
        :searching-ellipse "جاري البحث..."
        :i-am "أنا:"
        :none-of-the-above "لا شيء مما ورد أعلاه"
        :search-usage-alttag "تعليمات استخدام أداة البحث"
        :logo-alt-tag "شعار البوصلة الخاصة بتطبيق Ballot Scout"
        :mailbox-error-alttag
        "صورة لصندوق بريد به علامة تعجب حمراء للإشارة إلى حدوث خطأ ما."
        :powered-by [[:span#powered-by "مشغل بواسطة"] [:span#democracy-works "%1"]]
        :footer-questions-call ["هل لديك أسئلة؟ للتواصل مع "
                                [:span {:dir "ltr"} " %1 "] " اتصل على  " [:p " %2 "]]
        :call-office ["اتصل بمكتب انتخابات %1"]
        :email-office ["أرسل بريدًا إلكترونيًّا لمكتب انتخابات %1"]
        :or-email [" أو البريد الإلكتروني %1"]
        :notifications "الإشعارات"
        :subscribe-me "اجعلني مشتركًا"
        :email-address "عنوان البريد الإلكتروني"
        :phone-number "رقم الهاتف"
        :already-signed-up "لقد سجلت الاشتراك بالفعل لتلقي إشعارات %1."
        :unable-to-process
        "لم نتمكن من معالجة اشتراك %1 الخاص بك، يُرجى إعادة المحاولة في وقت لاحق."
        :youve-subscribed "لقد اشتركت في الإشعارات عبر %1"
        :youre-subscribed "أنت مُشترك"
        :email "البريد الإلكتروني"
        :sms "الرسائل النصية القصيرة"
        :send-me-email "أرسل لي التحديثات عبر البريد الإلكتروني"
        :send-me-sms "أرسل لي التحديثات عبر الرسائل النصية (SMS)"
        :check-email "راجع بريدك الإلكتروني لتأكيد الاشتراك"
        :check-texts "راجع رسائلك النصية لتأكيد الاشتراك"
        :update-email "حدِّث البريد الإلكتروني"
        :update-phone "حدِّث رقم الهاتف"
        :you-have-been-unsubscribed "لقد تم إلغاء الاشتراك"
        :resubscribe "لإعادة الاشتراك، أرسل رسالة مكتوب بها \"YES\" على رقم %1"
        :election "الانتخابات"
        :Election "الانتخابات"
        :last-updated "تم آخر تحديث في: %1"
        :it-was-last-scanned-in-city-state " تم فحصها لآخر مرة في %1، %2. "
        :it-was-last-scanned-usps "تم فحصها آخر مرة بواسطة الخدمة البريدية للولايات المتحدة في %1، %2 بتاريخ %3"
        ; -- Widget Statuses --
        :not-tracked "غير خاضعة للتتبع"
        :being-prepared "يجري إعدادها"
        :not-yet-mailed "لم يُرسل بالبريد بعد"
        :mailed-to-voter "أرسلت بالبريد إليك"
        :out-for-delivery-to-voter "خرجت للتوصيل إليك"
        :in-transit-to-voter "في طريقها إليك"
        :delivery-scheduled "تمت جدولة التوصيل"
        :mailed-to-office "أُرسلت إلى المكتب"
        :mailed-back-to-office "أعيد إرسالها بالبريد إلى المكتب"
        :in-transit-to-office "في طريقها إلى المكتب"
        :out-for-delivery-to-office "خرجت للتوصيل إلى المكتب"
        :received "تم الاستلام"
        :received-by-office "استلمها المكتب"
        :received-by-office-accepted "استلمها المكتب – مقبولة"
        :received-by-office-flagged "استلمها المكتب – وُضعت علامة عليها"
        :returned-to-sender "تمت الإعادة إلى المرسل"
        ; -- Explanations Messages --
        :unable-to-deliver
        "لم يتمكن مكتب البريد من تسليم بطاقة تصويتك لسببٍ ما. يُرجى التواصل مع مكتب الانتخابات باستخدام تفاصيل جهة الاتصال الواردة أدناه."
        :unable-to-deliver-2 "لم يتمكن مكتب البريد من توصيل بطاقة اقتراعك لسبب ما. "
        :learn-more-contact-office "لمعرفة المزيد، يُرجى الاتصال بمكتب الانتخابات."
        :ballot-accepted-on
        "تم قبول بطاقة تصويتك من قبل مكتب الانتخابات في %1. "
        :issue-with-ballot "قد تكون هناك مشكلة في بطاقة تصويتك. "
        :please-contact-office
        "يُرجى الاتصال بمكتب الانتخابات المحلي الخاص بك على "
        :not-tracked-explanation "لا يتم تتبع بطاقة تصويتك حاليًا. "
        :not-yet-mailed-explanation
        "يجري تحضير بطاقة تصويتك للإرسال عبر بالبريد. "
        :not-yet-mailed-explanation-2
        "لم يتم إرسال بطاقة اقتراعك بريديًّا بعد. يُرجى التحقق لاحقًا للحصول على معلومات مُحدَّثة أو قم بالتسجيل للحصول على الإشعارات حتى تبقى على اطلاع تلقائيًّا."
        :check-back-soon
        " تحقق مرة أخرى في أقرب وقت للحصول على أحدث المعلومات."
        :voter-bound-mailed-explanation
        "تم إرسال بطاقة تصويتك عبر البريد وهي في طريقها إليك. "
        :voter-bound-in-transit-explanation
        "بطاقة تصويتك في طريقها إليك عبر البريد! "
        :voter-bound-delivered-explanation
        "بناءً على بيانات USPS، ينبغي أن تتوقع وصول بطاقة تصويتك يوم/حوالي يوم%1. "
        :voter-bound-delivered-explanation-2
        "وفقًا لبيانات الخدمة البريدية للولايات المتحدة، نتوقع أن تصلك بطاقة الاقتراع على عنوانك بتاريخ/بحلول %1. "
        :office-bound-mailed-explanation
        "لقد قمت بإعادة بطاقة تصويتك إلى مكتب البريد وجاري إعادة إرسالها إلى مكتب الانتخابات. "
        :office-bound-in-transit-explanation
        "جاري نقل بطاقة تصويتك عبر البريد وهي في طريقها إلى مكتب الانتخابات. "
        :office-bound-delivered-explanation-on
        "كان من المفترض أن يتم استلام بطاقة التصويت الخاصة بك من قبل مكتب الانتخابات في %1. "
        :office-bound-delivered-explanation
        "من المفترض أن تكون بطاقة تصويتك قد تم استلامها لدى مكتب الانتخابات. "
        :they-should-receive-it-by-eod
        "ينبغي لهم استلامها بنهاية اليوم في %1. "
        :if-there-are-problems
        "إذا كانت هناك مشاكل بخصوص بطاقة تصويتك، فسيتم إشعارك من قبل مسؤولي الانتخابات."
        :vote! "صوّت!"
        :vote-instructions "اتبع التعليمات الموجودة على بطاقة الاقتراع والمظروف حتى تتمكن من إدلاء صوتك!"
        :continue "تابع"
        :subscribe "الإشتراك"
        :unsubscribe "إلغاء الاشتراك"
        :you-have-signed-up-to-email-notys "لقد سجلت بنجاح لتلقي إشعارات تتبُع بطاقات الاقتراع عبر البريد الإلكتروني."
        :sorry! "عذرًا!"
        :could-not-verify-email "لم نتمكن من التحقق من بريدك الإلكتروني."
        :you-have-been-unsubscribed-from-email-notys "لقد ألغيت اشتراك تلقي إشعارات تتبُع الاقتراع عبر البريد الإلكتروني."
        :error-processing-unsubcribe "حدث خطأ أثناء معالجة طلب إلغاء اشتراكك."
        :loading-ellipses "جارٍ التحميل..."
        :thank-you! "شكرًا لك!"
        :thanks-for-voting "شكرًا على التصويت!"
        :learn-more "معرفة المزيد"
        :privacy "الخصوصية"
        :terms "الشروط"}
   :es {:endonym "Español"
        :missing "**ILOCALIZABLE**"
        :track-your-ballot "Haga seguimiento a su boleta electoral"
        :select-language "Seleccione el idioma"
        :select-election "Seleccionar elección"
        :required-field "Campo obligatorio"
        :name "Nombre"
        :name-description "Su nombre, según figura en el registro electoral"
        :your-name "Su nombre"
        :first-name "Nombre"
        :last-name "Apellido"
        :address "Dirección "
        :address-description "La dirección a la que pidió que se envíe su boleta electoral"
        :address-1-placeholder "Dirección o apartado postal"
        :address-2-placeholder "Dto., habitación, unidad o edificio"
        :ballot-address "Su dirección de correo para la recepción de la boleta electoral"
        :addr-line-1 "Dirección línea 1"
        :addr-line-2 "Dirección línea 2"
        :city "Ciudad"
        :state "Estado"
        :select-state "Elija su estado"
        :zip "Código postal"
        :yes-receive-notys "Sí, me gustaría recibir notificaciones por correo electrónico o mensaje de texto (SMS) sobre el estado de mi boleta electoral."
        :submit "Buscar"
        :fields-invalid "La entrada del campo resaltado a continuación no es válida. Por favor, corrija la entrada y vuelva a enviar el formulario."
        :unable-locate-ballot "Lo sentimos, no hemos podido localizar su boleta electoral en este momento. Por favor, compruebe su información y vuelva a enviar el formulario o inténtelo más tarde."
        :unable-locate-ballot-2 "La información que introdujo no coincide con ninguna de las boletas electorales que tenemos en el sistema. Compruebe que la información sea correcta y vuelva a subir el formulario, o bien vuelva a intentarlo pasados unos minutos."
        :multiple-ballots-found "Hemos encontrado varias coincidencias potenciales para la información que ha introducido - por favor, elija la información correcta de la lista de abajo."
        :ballot-located "Su boleta electoral ha sido localizada"
        :we-found-multiple-elections "Encontramos boletas electorales para múltiples elecciones."
        :choose-an-election "Elija una de las siguientes opciones para obtener más detalles."
        :partner-not-found "Socio no encontrado"
        :searching-ellipse "Buscando..."
        :i-am "Soy:"
        :none-of-the-above "Ninguna de las anteriores"
        :search-usage-alttag "Instrucciones de uso del widget de búsqueda"
        :logo-alt-tag "Logotipo de la brújula de Ballot Scout"
        :mailbox-error-alttag "Imagen de un buzón con un signo de exclamación rojo para indicar que algo ha salido mal"
        :powered-by [[:span#powered-by "con la ayuda de"] [:span#democracy-works "%1"]]
        :footer-questions-call ["¿Preguntas? Para ponerse en contacto con %1, llame al %2"]
        :call-office ["Llame a la oficina electoral del %1"]
        :email-office ["Envíe un correo electrónico a la oficina electoral del %1"]
        :or-email [" o correo electrónico %1"]
        :notifications "Notificaciones"
        :subscribe-me "Suscribirme"
        :email-address "Correo electrónico"
        :phone-number "Número de teléfono"
        :already-signed-up "Ya se ha suscrito a las notificaciones de %1."
        :unable-to-process "No hemos podido procesar su suscripción de %1, por favor inténtelo más tarde."
        :youve-subscribed "Se ha suscrito a las notificaciones a través de %1"
        :youre-subscribed "Se ha suscrito"
        :email "Correo electrónico"
        :sms "Mensaje de texto"
        :send-me-email "Envíenme notificaciones por correo electrónico"
        :send-me-sms "Envíenme notificaciones por mensaje de texto (SMS)"
        :check-email "Confirme su suscripción yendo a su correo electrónico"
        :check-texts "Confirme su suscripción yendo a sus mensajes de texto"
        :update-email "Actualizar el correo electrónico"
        :update-phone "Actualizar el número de teléfono"
        :you-have-been-unsubscribed "Ha cancelado la suscripción"
        :resubscribe "Para volver a suscribirse, envíe 'YES' al %1"
        :election "elección"
        :Election "Elección"
        :last-updated "Última actualización: %1"
        :it-was-last-scanned-in-city-state " Se escaneó por última vez en %1, %2. "
        :it-was-last-scanned-usps "Fue escaneada por última vez por el USPS en %1, %2, el %3"
        ; -- Widget Statuses --
        :not-tracked "No se ha hecho seguimiento"
        :being-prepared "En trámite"
        :not-yet-mailed "Aún no se ha enviado por correo"
        :mailed-to-voter "Enviada por correo a usted"
        :out-for-delivery-to-voter "En ruta para la entrega a usted"
        :in-transit-to-voter "En tránsito hacia usted"
        :delivery-scheduled "Entrega programada"
        :mailed-to-office "Enviada por correo a la oficina"
        :mailed-back-to-office "Devuelta a la oficina"
        :in-transit-to-office "En tránsito a la oficina"
        :out-for-delivery-to-office "En ruta para la entrega en la oficina"
        :received "Recibida"
        :received-by-office "Recibida por la oficina"
        :received-by-office-accepted "Recibida por la oficina: aceptada"
        :received-by-office-flagged "Recibida por la oficina: marcada"
        :returned-to-sender "Devuelta al remitente"
        ; -- Explanations Messages --
        :unable-to-deliver "La oficina de correos no ha podido entregar su boleta electoral por algún motivo. Póngase en contacto con la oficina electoral utilizando los datos de contacto que figuran a continuación."
        :unable-to-deliver-2 "Por algún motivo, la oficina de correos no pudo entregar su boleta electoral. "
        :learn-more-contact-office "Para obtener más información, póngase en contacto con su oficina electoral."
        :ballot-accepted-on "Su boleta electoral fue aceptada por la oficina electoral en %1. "
        :issue-with-ballot "Podría haber un problema con su boleta electoral. "
        :please-contact-office "Póngase en contacto con la oficina electoral al teléfono %1"
        :not-tracked-explanation "Su boleta electoral no tiene seguimiento actualmente. "
        :not-yet-mailed-explanation "Su boleta electoral se está preparando para el envío por correo. "
        :not-yet-mailed-explanation-2 "Aún no hemos enviado su boleta electoral. Ingrese de nuevo más tarde para ver si hay novedades o inscríbase para recibir notificaciones automáticas de todas las novedades."
        :check-back-soon " Vuelva pronto para obtener información actualizada."
        :voter-bound-mailed-explanation "Su boleta electoral se ha enviado por correo y está en camino a usted. "
        :voter-bound-in-transit-explanation "¡Su boleta electoral está en el correo y en camino a usted! "
        :voter-bound-delivered-explanation "Según la información del USPS, su boleta electoral debería llegar el / alrededor de %1. "
        :voter-bound-delivered-explanation-2 "En función de los datos del USPS, la boleta electoral debería llegar a su dirección el %1 o sobre esa fecha. "
        :office-bound-mailed-explanation "Ha devuelto su boleta electoral a la oficina de correos y esta se reenviará a la oficina electoral."
        :office-bound-in-transit-explanation "Su boleta electoral está en curso por correo a la oficina electoral. "
        :office-bound-delivered-explanation-on "Su boleta electoral debió recibirse por la oficina electoral el %1. "
        :office-bound-delivered-explanation "Su boleta electoral debió recibirse en la oficina electoral. "
        :they-should-receive-it-by-eod "Deberían recibirla al final del día el %1. "
        :if-there-are-problems "Si hay problemas con su boleta electoral, los funcionarios electorales se lo notificarán."
        :vote! "¡Vota!"
        :vote-instructions "¡Siga las indicaciones de la boleta electoral y del sobre para votar!"
        :continue "Continúa"
        :subscribe "Suscribir"
        :unsubscribe "Darse de baja"
        :you-have-signed-up-to-email-notys "Empezará a recibir notificaciones del seguimiento de las boletas electorales por correo electrónico."
        :sorry! "¡Lo siento!"
        :could-not-verify-email "No pudimos verificar tu correo electrónico"
        :you-have-been-unsubscribed-from-email-notys "Ha cancelado su suscripción a las notificaciones del seguimiento de las boletas electorales por correo electrónico."
        :error-processing-unsubcribe "Hubo un error al procesar tu solicitud de cancelación de la suscripción"
        :loading-ellipses "Cargando..."
        :thank-you! "¡Muchas gracias por suscribirse!"
        :thanks-for-voting "¡Gracias por votar!"
        :learn-more "Más información"
        :privacy "Privacidad"
        :terms "Condiciones"}
   :zh {:they-should-receive-it-by-eod "他们应在 %1 下班前收到选票。 "
        :returned-to-sender "已退回发件人"
        :last-updated "上次更新时间：%1"
        :not-tracked-explanation "目前未跟踪您的选票。 "
        :voter-bound-in-transit-explanation "您的选票正在运送给您的途中！ "
        :received "已收到"
        :received-by-office "办公室已收到"
        :received-by-office-accepted "办公室已收到 - 已接受"
        :received-by-office-flagged "办公室已收到 - 已标记"
        :issue-with-ballot "您的选票可能有问题。"
        :email "电子邮件地址"
        :last-name "姓氏"
        :youve-subscribed "您已通过 %1 订阅通知"
        :youre-subscribed "您已订阅 "
        :we-found-multiple-elections "我们发现多个选举的选票。"
        :phone-number "电话号码"
        :already-signed-up "您已注册接收 %1 通知。"
        :office-bound-delivered-explanation-on "您的选票应在 %1 送达选举办公室。 "
        :in-transit-to-office "正在中转到办公室"
        :your-name "您的姓名"
        :footer-questions-call ["有疑问？要联系 %1，请致电 %2"]
        :call-office ["致电 %1 选举办公室"]
        :email-office ["发送邮件至 %1 选举办公室"]
        :unable-to-deliver "出于某些原因，邮局无法投递您的选票。请通过以下联系方式联系选举办公室。"
        :unable-to-deliver-2 "由于某些原因，邮局无法投递您的选票。"
        :learn-more-contact-office "如需了解更多详情，请联系选举办公室。"
        :searching-ellipse "正在搜索..."
        :city "城市"
        :endonym "中文"
        :voter-bound-delivered-explanation "根据 USPS 数据，您的选票应在以下时间前后到达： %1. "
        :voter-bound-delivered-explanation-2 "基于 USPS 数据，您的选票将于 %1 左右送到您的住处。"
        :it-was-last-scanned-in-city-state " 上次于 %2 %1 扫描。 "
        :it-was-last-scanned-usps "由 USPS 于 %3 在 %1 %2 进行最后一次扫描"
        :submit "搜索"
        :or-email [" 或电子邮件地址 %1"]
        :not-tracked "未跟踪"
        :powered-by [[:span#powered-by "技术支持："] [:span#democracy-works "%1"]]
        :please-contact-office "请联系本地选举办公室，联系方式为 %1"
        :state "州/省"
        :select-state "选择州"
        :choose-an-election "请选择以下选举之一了解更多详细信息。"
        :first-name "名字"
        :unable-to-process "我们无法处理您的 %1 订阅，请稍后重试。"
        :out-for-delivery-to-office "正在投递到办公室"
        :search-usage-alttag "搜索小组件使用说明"
        :check-back-soon " 即刻返回查看更新信息。"
        :office-bound-in-transit-explanation "您的选票正在通过邮件运送到选举办公室的途中。 "
        :none-of-the-above "以上皆否"
        :election "选举"
        :Election "选举"
        :address "地址"
        :address-description "您要求将选票邮寄到的地址 "
        :address-1-placeholder "街道地址或邮政信箱"
        :address-2-placeholder "公寓、套房、单元或建筑"
        :ballot-address "您的选票邮寄地址"
        :notifications "通知"
        :subscribe-me "订阅我"
        :mailed-to-voter "已邮寄给您"
        :not-yet-mailed-explanation "正在准备您的选票以便进行邮寄。 "
        :not-yet-mailed-explanation-2 "尚未邮寄您的选票。请稍后返回查看更新信息或者注册通知以自动获取最新信息。"
        :ballot-located "已定位您的选票"
        :i-am "我是："
        :zip "邮政编码"
        :addr-line-1 "地址行 1"
        :out-for-delivery-to-voter "正在投递给您"
        :if-there-are-problems "如果您的选票有问题，您将收到选举官员的通知。"
        :multiple-ballots-found "我们发现您输入的信息存在多个可能的匹配项，请从以下列表中选择正确的信息。"
        :office-bound-mailed-explanation "您的选票已寄回邮局并正在送回选举办公室的途中。"
        :sms "短信"
        :send-me-email "向我发送电子邮件更新"
        :send-me-sms "向我发送短信 (SMS) 更新"
        :check-email "检查您的电子邮箱以确认订阅"
        :check-texts "检查您的短信以确认订阅"
        :update-email "更新电子邮件"
        :update-phone "更新电话号码"
        :you-have-been-unsubscribed "您已取消订阅"
        :resubscribe "重新订阅文本 \"YES\" 至 %1"
        :fields-invalid "以下突出显示的字段条目无效。请更正条目并重新提交表格。"
        :email-address "电子邮件地址"
        :missing "**缺失**"
        :unable-locate-ballot "很抱歉，我们目前无法定位您的选票。请再次检查您的信息并重新提交表格，或稍后重试。"
        :unable-locate-ballot-2 "您输入的信息与我们系统中的任何选票都不匹配。请再次检查您的信息并重新提交表格或稍后重试。"
        :delivery-scheduled "已安排投递"
        :mailed-to-office "邮寄至办公室"
        :mailed-back-to-office "已寄回办公室"
        :partner-not-found "未找到合作伙伴"
        :addr-line-2 "地址行 2"
        :ballot-accepted-on "选举办公室已于 %1 接受您的选票. "
        :yes-receive-notys "是，我想接收选票状态电子邮件或短信 (SMS) 通知。"
        :logo-alt-tag "Ballot Scout 罗盘徽标"
        :mailbox-error-alttag "带有红色惊叹号的信箱图像表示出错"
        :voter-bound-mailed-explanation "您的选票已寄出并正在运送给您的途中。 "
        :in-transit-to-voter "正在中转给您"
        :office-bound-delivered-explanation "您的选票应该已送达选举办公室。 "
        :being-prepared "正在准备中"
        :not-yet-mailed "尚未邮寄"
        :track-your-ballot "跟踪您的选票"
        :select-language "选择语言"
        :select-election "选择选举"
        :required-field "必填字段"
        :name "姓名"
        :name-description "您的选民登记中显示的姓名 "
        :vote! "投票"
        :vote-instructions "按照选票和信封上的说明投票！"
        :continue "继续"
        :subscribe "订阅"
        :unsubscribe "退订"
        :thank-you! "谢谢！"
        :thanks-for-voting "感谢投票！"
        :learn-more "了解更多信息"
        :privacy "隐私"
        :terms "条款"
        :you-have-signed-up-to-email-notys "您已成功注册通过电子邮件接收投票跟踪通知。"
        :sorry! "抱歉！"
        :could-not-verify-email "我们无法验证您的电子邮件。"
        :you-have-been-unsubscribed-from-email-notys "您已取消通过电子邮件订阅投票跟踪通知。"
        :error-processing-unsubcribe "处理您的取消订阅请求时出现错误。"
        :loading-ellipses "正在加载……"}
   :vi {:they-should-receive-it-by-eod
        "Họ sẽ nhận được nó trước cuối ngày %1. "
        :returned-to-sender "Đã trả lại cho người gửi"
        :last-updated "Cập nhật lần cuối: %1"
        :not-tracked-explanation
        "Lá phiếu của bạn hiện không được theo dõi. "
        :voter-bound-in-transit-explanation
        "Lá phiếu của bạn đang được gửi cho bạn! "
        :received "Đã nhận"
        :received-by-office "Đã nhận bởi Văn phòng"
        :received-by-office-accepted "Đã nhận bởi Văn phòng - Đã Chấp Nhận"
        :received-by-office-flagged "Đã nhận bởi Văn phòng - Đã Đánh Dấu"
        :issue-with-ballot "Có thể có vấn đề với lá phiếu của bạn. "
        :email "Email"
        :last-name "Họ"
        :youve-subscribed "Bạn đã đăng ký nhận thông báo qua %1"
        :youre-subscribed "Quý vị đã đăng ký."
        :we-found-multiple-elections
        "Chúng tôi tìm thấy các lá phiếu cho nhiều cuộc bầu cử."
        :phone-number "Số điện thoại"
        :already-signed-up "Bạn đã đăng ký nhận thông báo %1."
        :office-bound-delivered-explanation-on
        "Lá phiếu của bạn sẽ được văn phòng bầu cử nhận vào %1. "
        :in-transit-to-office "Đang vận chuyển đến văn phòng"
        :your-name "Tên của Bạn"
        :footer-questions-call
        ["Bạn có thắc mắc? Để liên hệ %1, hãy gọi số %2"]
        :call-office ["Gọi Văn phòng Bầu cử %1"]
        :email-office ["Gửi email đến Văn phòng Bầu cử %1"]
        :unable-to-deliver
        "Bưu điện không thể giao lá phiếu của bạn vì lý do nào đó. Vui lòng liên hệ với văn phòng bầu cử địa phương bằng cách sử dụng các chi tiết liên hệ bên dưới."
        :unable-to-deliver-2 "Bưu điện không thể gửi phiếu bầu của bạn vì một vài lý do. "
        :learn-more-contact-office "Để biết thêm thông tin, vui lòng liên hệ văn phòng bầu cử."
        :searching-ellipse "Đang tìm kiếm..."
        :city "Thành phố"
        :endonym "Tiếng Việt"
        :voter-bound-delivered-explanation "Dựa trên dữ liệu USPS, bạn nên chờ đợi lá phiếu của bạn đến nơi vào/vào khoảng %1. "
        :voter-bound-delivered-explanation-2 "Dựa trên dữ liệu của USPS, lá phiếu sẽ đến địa chỉ của bạn vào/khoảng %1. "
        :it-was-last-scanned-in-city-state
        " Nó được scan lần cuối ở %1, %2. "
        :it-was-last-scanned-usps "USPS )Dịch vụ Bưu chính Hoa Kỳ) đã scan lần cuối ở %1, %2 vào ngày %3"
        :submit "Tìm kiếm"
        :or-email [" hoặc email %1"]
        :not-tracked "Chưa theo dõi"
        :powered-by [[:span#powered-by "tài trợ bởi"] [:span#democracy-works "%1"]]
        :please-contact-office
        "Vui lòng liên hệ với văn phòng bầu cử tại địa phương của bạn qua %1"
        :state "Tiểu bang"
        :select-state "Chọn Tiểu bang"
        :choose-an-election
        "Vui lòng chọn một trong các cuộc bầu cử sau đây để biết thêm chi tiết."
        :first-name "Tên"
        :unable-to-process
        "Chúng tôi không thể xử lý đăng ký %1 của bạn, vui lòng thử lại sau."
        :out-for-delivery-to-office "Đưa đi giao đến văn phòng"
        :search-usage-alttag "Hướng dẫn sử dụng ứng dụng con tìm kiếm"
        :check-back-soon " Sớm kiểm tra trở lại để biết thông tin cập nhật."
        :office-bound-in-transit-explanation
        "Lá phiếu của bạn đang được gửi qua bưu điện và đang trên đường đến văn phòng bầu cử. "
        :none-of-the-above "Không có trường hợp nào bên trên"
        :election "bầu cử"
        :Election "Bầu cử"
        :address "Địa Chỉ"
        :address-description "Bạn đã yêu cầu gửi lá phiếu của mình đến địa chỉ nào"
        :address-1-placeholder "Địa chỉ hoặc Hộp thư"
        :address-2-placeholder "Căn hộ, Phòng, Tòa Nhà hoặc Chung Cư"
        :ballot-address "Địa Chỉ Nhận Lá Phiếu Của Bạn"
        :notifications "Thông Báo"
        :subscribe-me "Đăng Ký Cho Tôi"
        :mailed-to-voter "Đã gửi cho bạn"
        :not-yet-mailed-explanation
        "Lá phiếu của bạn đang được chuẩn bị để gửi. "
        :not-yet-mailed-explanation-2 "Phiếu bầu của bạn vẫn chưa được gửi. Kiểm tra lại sau để cập nhật thông tin hoặc đăng ký nhận thông báo để được cập nhật thông tin tự động."
        :ballot-located "Lá Phiếu Của Bạn Đã Được Định Vị"
        :i-am "Tôi là:"
        :zip "Mã Zip"
        :addr-line-1 "Dòng địa chỉ 1"
        :out-for-delivery-to-voter "Đưa đi giao đến bạn"
        :if-there-are-problems
        "Nếu có vấn đề với lá phiếu của bạn, bạn sẽ được các quan chức bầu cử thông báo."
        :multiple-ballots-found
        "Chúng tôi tìm thấy nhiều kết quả kớp có thể có đối với thông tin bạn nhập - vui lòng chọn thông tin chính xác từ danh sách bên dưới."
        :office-bound-mailed-explanation
        "Bạn đã gửi lại lá phiếu của bạn cho bưu điện và nó đang được gửi lại cho văn phòng bầu cử."
        :sms "SMS"
        :send-me-email "Hãy gửi cho tôi email cập nhật"
        :send-me-sms "Hãy gửi cho tôi tin nhắn (SMS) cập nhật"
        :check-email "Hãy kiểm tra email của quý vị để xác nhận đăng ký"
        :check-texts "Hãy kiểm tra tin nhắn của quý vị để xác nhận đăng ký"
        :update-email "Cập nhật email"
        :update-phone "Cập nhật số điện thoại"
        :you-have-been-unsubscribed "Quý vị đã hủy đăng ký"
        :resubscribe "Để đăng ký lại, vui lòng nhắn \"YES\" đến %1"
        :fields-invalid
        "Mục nhập trường được tô sáng bên dưới là không hợp lệ. Vui lòng sửa mục nhập và gửi lại mẫu đơn."
        :email-address "Địa chỉ email"
        :missing "**THIẾU**"
        :unable-locate-ballot
        "Chúng tôi rất tiếc, chúng tôi không thể tìm lá phiếu của bạn vào lúc này. Vui lòng kiểm tra lại thông tin của bạn và gửi lại mẫu đơn hoặc thử lại sau."
        :unable-locate-ballot-2 "Thông tin bạn vừa điền không khớp với bất kỳ phiếu bầu nào trên hệ thống. Hãy kiểm tra lại thông tin và điền lại đơn hoặc thử lại sau."
        :delivery-scheduled "Đã lên lịch giao"
        :mailed-to-office "Đã gửi đến Văn phòng"
        :mailed-back-to-office "Đã gửi lại văn phòng"
        :partner-not-found "Không tìm thấy đối tác"
        :addr-line-2 "Dòng địa chỉ 2"
        :ballot-accepted-on
        "Lá phiếu của bạn đã được văn phòng bầu cử chấp nhận vào %1. "
        :yes-receive-notys
        "Có, tôi muốn nhận thông báo email hoặc tin nhắn văn bản (SMS) về trạng thái lá phiếu của tôi."
        :logo-alt-tag "Logo la bàn Ballot Scout"
        :mailbox-error-alttag
        "Hình ảnh một hộp thư có dấu than màu đỏ cho biết rằng đã có vấn đề gì đó"
        :voter-bound-mailed-explanation
        "Lá phiếu của bạn đã được gửi và đang trên đường gửi đến cho bạn. "
        :in-transit-to-voter "Trên đường vận chuyển đến bạn"
        :office-bound-delivered-explanation
        "Lá phiếu của bạn sẽ được văn phòng bầu cử nhận. "
        :being-prepared "Đang Được Chuẩn Bị"
        :not-yet-mailed "Chưa gửi"
        :track-your-ballot "Theo Dõi Lá Phiếu Của Bạn"
        :select-language "Chọn Ngôn Ngữ"
        :select-election "Chọn Cuộc Bầu Cử"
        :required-field "Thông Tin Bắt Buộc"
        :name "Tên"
        :name-description "Tên xuất hiện trên phiếu đăng ký cử tri của bạn"
        :vote! "Hãy bầu cử!"
        :vote-instructions "Làm theo hướng dẫn trên lá phiếu và phong bì để bầu cử!"
        :continue "Tiếp tục"
        :subscribe "Đăng ký tôi"
        :unsubscribe "Hủy đăng ký"
        :thank-you! "Xin cảm ơn!"
        :thanks-for-voting "Cảm ơn vì đã bầu cử!"
        :learn-more "Xem Thêm"
        :privacy "Quyền riêng tư"
        :terms "Điều khoản"
        :you-have-signed-up-to-email-notys "Quý vị đã đăng ký thành công để nhận thông báo theo dõi phiếu bầu qua email."
        :sorry! "Rất tiếc!"
        :could-not-verify-email "Chúng tôi không thể xác minh email của quý vị."
        :you-have-been-unsubscribed-from-email-notys "Quý vị đã hủy đăng ký nhận thông báo theo dõi phiếu bầu qua email."
        :error-processing-unsubcribe "Đã xảy ra lỗi khi xử lý yêu cầu hủy đăng ký của quý vị."
        :loading-ellipses "Đang tải..."}
   :ko {:they-should-receive-it-by-eod "%1까지 도착할 예정입니다. "
        :returned-to-sender "발송인에게 반송"
        :last-updated "최신 업데이트: %1"
        :not-tracked-explanation "귀하의 투표용지는 현재 추적되지 않습니다. "
        :voter-bound-in-transit-explanation "투표용지가 우편으로 발송되어 댁으로 가고 있는 중입니다. "
        :received "수령"
        :received-by-office "사무소 접수"
        :received-by-office-accepted "사무소 접수 - 수락됨"
        :received-by-office-flagged "사무소 접수 - 표시됨"
        :issue-with-ballot "귀하의 투표용지에 문제가 있는 것 같습니다. "
        :email "이메일"
        :last-name "성"
        :youve-subscribed "%1을 통해 알림을 신청하셨습니다."
        :youre-subscribed "구독을 신청했습니다."
        :we-found-multiple-elections "여러 선거의 투표용지가 있습니다."
        :phone-number "전화번호"
        :already-signed-up "%1 알림을 이미 신청하셨습니다."
        :office-bound-delivered-explanation-on
        "귀하의 투표용지는 선거관리위원회가 %1에 수령한 것으로 여겨집니다. "
        :in-transit-to-office "위원회로 우송 중"
        :your-name "귀하의 이름"
        :footer-questions-call ["궁금한 점이 있으신가요? %1에 연락하려면, %2로 전화하세요."]
        :call-office ["%1 선거사무소에 전화하십시오"]
        :email-office ["%1 선거사무소에 이메일하십시오"]
        :unable-to-deliver
        "우편국이 어떤 이유로 귀하의 투표용지를 배달하지 못했습니다. 다음의 연락처로 선거관리위원회에 문의하여 주시기 바랍니다."
        :unable-to-deliver-2 "우체국은 어떤 이유로 귀하의 투표용지를 전달하지 못했습니다. "
        :learn-more-contact-office "자세한 내용은 선거사무소에 문의하십시오."
        :searching-ellipse "검색 중..."
        :city "시"
        :endonym "한국어"
        :voter-bound-delivered-explanation "USPS의 정보에 따르면 귀하의 투표용지는 %1 에 도착할 예정입니다. "
        :voter-bound-delivered-explanation-2 "USPS 데이터에 따르면 투표용지는 %1에 귀하의 주소로 도착할 예정입니다. "
        :it-was-last-scanned-in-city-state " 마지막 스캔 위치는 %2 주 %1 시입니다. "
        :it-was-last-scanned-usps "%3에 %2, %1 에서 USPS가 마지막으로 스캔했습니다"
        :submit "검색"
        :or-email [" 또는 이메일 %1"]
        :not-tracked "추적 불가"
        :powered-by [[:span#democracy-works "%1"] [:span#powered-by "운영"]]
        :please-contact-office "%1 (으)로 지역 선거관리위원회에 문의해 주세요"
        :state "주"
        :select-state "주 선택"
        :choose-an-election "다음 선거 중 하나를 선택하시면 자세한 내용을 열람하실 수 있습니다."
        :first-name "이름"
        :unable-to-process "%1 신청을 처리할 수 없습니다. 나중에 다시 시도해 주십시오."
        :out-for-delivery-to-office "위원회로 배달하고자 나감"
        :search-usage-alttag "위젯 사용지침을 검색"
        :check-back-soon " 업데이트된 정보를 바로 확인하세요."
        :office-bound-in-transit-explanation
        "투표용지가 우편으로 발송되어 선거관리위원회로 가고 있는 중입니다. "
        :none-of-the-above "해당 사항 없음"
        :election "선거"
        :Election "선거"
        :address "주소"
        :address-description "투표용지 우편 발송 요청 주소"
        :address-1-placeholder "거리 주소 또는 우편사서함"
        :address-2-placeholder "아파트, 호수, 동 또는 건물"
        :ballot-address "투표용지 우송주소"
        :notifications "알림"
        :subscribe-me "구독하기"
        :mailed-to-voter "귀하의 주소지로 발송"
        :not-yet-mailed-explanation "귀하의 투표용지를 준비하고 있습니다. "
        :not-yet-mailed-explanation-2 "귀하의 투표용지는 아직 우편으로 발송되지 않았습니다. 업데이트된 정보를 나중에 다시 확인하거나 자동으로 업데이트 상태를 확인하려면 알림을 신청하십시오."
        :ballot-located "귀하의 투표용지를 찾았습니다."
        :i-am "본인:"
        :zip "우편번호"
        :addr-line-1 "상세주소 1"
        :out-for-delivery-to-voter "귀하의 주소지로 출발"
        :if-there-are-problems "투표용지에 문제가 있는 경우 선거관리위원회에서 알려드립니다."
        :multiple-ballots-found
        "입력하신 정보에 일치하는 항목이 여러 개 있습니다. 다음의 목록에서 올바른 정보를 선택하십시오."
        :office-bound-mailed-explanation
        "귀하는 투표용지를 우편국에 반송했습니다. 현재 투표용지는 선거관리위원회로 가고 있는 중입니다."
        :sms "SMS"
        :send-me-email "이메일 업데이트 수신하기"
        :send-me-sms "문자 메시지(SMS) 업데이트 수신하기"
        :check-email "구독을 확인하려면 이메일을 확인하십시오"
        :check-texts "구독을 확인하려면 문자를 확인하십시오"
        :update-email "이메일 업데이트"
        :update-phone "전화번호 업데이트"
        :you-have-been-unsubscribed "구독이 취소되었습니다"
        :resubscribe "재구독하려면 \"YES\" 라고 %1 번으로 문자하십시오"
        :fields-invalid "강조 표시된 입력 항목이 유효하지 않습니다. 내용을 수정하고 양식을 다시 제출해 주세요."
        :email-address "이메일 주소"
        :missing "**분실**"
        :unable-locate-ballot
        "죄송합니다. 귀하의 투표용지를 추적할 수 없습니다. 정보를 재확인하고 양식을 다시 제출하거나 나중에 다시 시도해 주십시오."
        :unable-locate-ballot-2 "입력하신 정보가 시스템의 투표용지와 일치하지 않습니다. 정보를 확인하고 양식을 다시 제출하거나 나중에 다시 시도하십시오."
        :delivery-scheduled "배달 예정"
        :mailed-to-office "사무소로 우편 발송"
        :mailed-back-to-office "위원회로 반송"
        :partner-not-found "파트너를 찾을 수 없음"
        :addr-line-2 "상세주소 2"
        :ballot-accepted-on "선거관리위원회가 %1에 귀하의 투표용지를 수락하였습니다. "
        :yes-receive-notys
        "예, 투표용지의 현재 상태에 관하여 이메일 또는 문자 메시지(SMS) 알림을 수신하겠습니다."
        :logo-alt-tag "Ballot Scout 컴퍼스 로고"
        :mailbox-error-alttag "빨간색 느낌표가 붙은 편지함은 문제가 생겼음을 의미함"
        :voter-bound-mailed-explanation
        "귀하의 투표용지가 우편으로 발송되어 댁으로 가고 있는 중입니다. "
        :in-transit-to-voter "귀하의 주소지로 우송 중"
        :office-bound-delivered-explanation
        "귀하의 투표용지는 선거관리위원회가 수령한 것으로 여겨집니다. "
        :being-prepared "준비중"
        :not-yet-mailed "미발송"
        :track-your-ballot "투표용지 추적"
        :select-language "언어 선택"
        :select-election "선거 선택"
        :required-field "필수 항목"
        :name "이름"
        :name-description "유권자 등록에 기록된 이름"
        :vote! "투표참여!"
        :vote-instructions "투표용지와 봉투의 지시에 따라 투표하십시오!"
        :continue "계속"
        :subscribe "구독하다"
        :unsubscribe "구독 취소"
        :thank-you! "감사합니다!"
        :thanks-for-voting "투표해주셔서 감사합니다!"
        :learn-more "자세히 알아보기"
        :privacy "개인정보"
        :terms "약관"
        :you-have-signed-up-to-email-notys "이메일을 통해 투표용지 추적 알림 수신을 성공적으로 등록했습니다."
        :sorry! "죄송합니다!"
        :could-not-verify-email "귀하의 이메일을 인증하지 못했습니다."
        :you-have-been-unsubscribed-from-email-notys "이메일을 통한 투표용지 추적 알림 수신이 취소되었습니다."
        :error-processing-unsubcribe "귀하의 탈퇴 요청 처리 중에 오류가 발생했습니다."
        :loading-ellipses "불러오기 중..."}
   :pl {:endonym "Polski"
        :missing "**ZAGINĘŁA**"
        :track-your-ballot "Śledź swoją kartę do głosowania"
        :select-language "Wybierz język"
        :select-election "Wybierz wybory"
        :required-field "Pole jest wymagane"
        :name "Imię i nazwisko"
        :name-description "Imię i nazwisko, które widnieje w rejestracji wyborcy"
        :your-name "Twoje imię i nazwisko"
        :first-name "Imię"
        :last-name "Nazwisko"
        :address "Adres"
        :address-description "Adres, na który została wysłana karta wyborcza"
        :address-1-placeholder "Ulica lub skrytka pocztowa"
        :address-2-placeholder "Mieszkanie, apartament, lokal lub budynek"
        :ballot-address "Adres wysyłkowy Twojej karty do głosowania"
        :addr-line-1 "Linia adresu 1"
        :addr-line-2 "Linia adresu 2"
        :city "Miejscowość"
        :state "Stan"
        :select-state "Wybierz stan"
        :zip "Kod pocztowy"
        :yes-receive-notys "Tak, chcę otrzymywać powiadomienia e-mail lub SMS dotyczące statusu mojej karty do głosowania."
        :submit "Wyszukaj"
        :fields-invalid "Wpis w oznaczonym polu jest nieprawidłowy. Popraw błędy i ponownie prześlij formularz."
        :unable-locate-ballot "Niestety, nie udało nam się zlokalizować Twojej karty do głosowania. Sprawdź podane informacje i ponownie prześlij formularz lub spróbuj ponownie później."
        :unable-locate-ballot-2 "Wprowadzone informacje nie pasują do żadnych kart wyborczych w naszym systemie. Prosimy dwukrotnie sprawdzić informacje i ponownie przesłać formularz lub spróbować ponownie później."
        :multiple-ballots-found "Znaleźliśmy wiele elementów pasujących do wprowadzonych przez Ciebie informacji — wybierz właściwe z listy poniżej."
        :ballot-located "Twoja karta do głosowania została zlokalizowana"
        :we-found-multiple-elections "Znaleźliśmy karty do głosowania w różnych wyborach."
        :choose-an-election "Aby zobaczyć więcej danych, wybierz jedne z poniższych wyborów."
        :partner-not-found "Nie znaleziono partnera"
        :searching-ellipse "Wyszukiwanie..."
        :i-am "Jestem:"
        :none-of-the-above "Żadne z powyższych"
        :search-usage-alttag "Przeszukaj instrukcję użytkowania widgetu"
        :logo-alt-tag "Logo Ballot Scout z kompasem"
        :mailbox-error-alttag "Obraz skrzynki pocztowej z czerwonym wykrzyknikiem oznaczający, że coś poszło nie tak"
        :powered-by [[:span#powered-by "obsługiwane przez"] [:span#democracy-works "%1"]]
        :footer-questions-call ["Czy masz pytania? Aby skontaktować się z %1, wybierz %2"]
        :call-office ["Zadzwoń do biura wyborczego w %1"]
        :email-office ["Wyślij wiadomość e-mail do biura wyborczego w %1"]
        :or-email [" lub e-mail %1"]
        :subscribe-me "Zapisz się"
        :notifications "Powiadomienia"
        :email-address "Adres e-mail"
        :phone-number "Numer telefonu"
        :already-signed-up "Już zapisałeś(-aś) się na powiadomienia %1."
        :unable-to-process "Nie udało nam się przetworzyć Twojej subskrypcji %1. Spróbuj ponownie później."
        :youve-subscribed "Zapisałeś(aś) się na powiadomienia za pośrednictwem %1"
        :youre-subscribed "Subskrypcja jest aktywna."
        :email "E-mail"
        :sms "SMS"
        :send-me-email "Chcę otrzymywać aktualizacje pocztą elektroniczną"
        :send-me-sms "Chcę otrzymywać aktualizacje jako wiadomości tekstowe (SMS)"
        :check-email "Prosimy sprawdzić swoje wiadomości e-mail, aby potwierdzić subskrypcję"
        :check-texts "Prosimy sprawdzić swoje wiadomości SMS, aby potwierdzić subskrypcję"
        :update-email "Zaktualizuj e-mail"
        :update-phone "Zaktualizuj numer telefonu"
        :you-have-been-unsubscribed "Subskrypcja została przerwana"
        :resubscribe "Aby odnowić subskrypcję, wyślij SMS o treści „YES” na numer %1"
        :election "wyborów"
        :Election "Wyborów"
        :last-updated "Ostatnia aktualizacja: %1"
        :it-was-last-scanned-in-city-state " Ostatni raz została zeskanowana w miejscowości %1, %2. "
        :it-was-last-scanned-usps " Ostatnio zeskanowana przez USPS w %1, %2 w dniu %3"
        :not-tracked "Brak śledzenia"
        :being-prepared "W przygotowaniu"
        :not-yet-mailed "Jeszcze nie wysłano"
        :mailed-to-voter "Wysłana do Ciebie"
        :out-for-delivery-to-voter "Wydana do doręczenia do Ciebie"
        :in-transit-to-voter "W drodze do Ciebie"
        :delivery-scheduled "Zaplanowano doręczenie"
        :mailed-to-office "Wysłana do biura"
        :mailed-back-to-office "Wysłana z powrotem do biura"
        :in-transit-to-office "W drodze do biura"
        :out-for-delivery-to-office "Wydana do doręczenia do biura"
        :received "Odebrana"
        :received-by-office "Otrzymana przez biuro"
        :received-by-office-accepted "Otrzymana przez biuro — zaakceptowana"
        :received-by-office-flagged "Otrzymana przez biuro — oznaczona"
        :returned-to-sender "Zwrot do nadawcy"
        :unable-to-deliver "Z jakiegoś powodu poczcie nie udało się dostarczyć Twojej karty do głosowania. Skontaktuj się z biurem wyborczym, korzystając z danych kontaktowych poniżej."
        :unable-to-deliver-2 "Z jakiegoś powodu poczta nie była w stanie dostarczyć Panu/Pani karty wyborczej. "
        :learn-more-contact-office "Aby dowiedzieć się więcej, prosimy skontaktować się z biurem wyborczym."
        :ballot-accepted-on "Twoja karta do głosowania została przyjęta przez biuro wyborcze %1. "
        :issue-with-ballot "Mógł pojawić się problem z Twoją kartą do głosowania. "
        :please-contact-office "Skontaktuj się z lokalnym biurem wyborczym pod "
        :not-tracked-explanation "Twoja karta do głosowania nie jest obecnie śledzona. "
        :not-yet-mailed-explanation "Twoja karta do głosowania jest przygotowywana do wysyłki. "
        :not-yet-mailed-explanation-2 "Pana/Pani karta wyborcza nie została jeszcze wysłana pocztą. Prosimy sprawdzić później, aby uzyskać aktualne informacje lub zapisać się w celu otrzymywania powiadomień i być na bieżąco ze wszystkim."
        :check-back-soon " Sprawdź wkrótce, czy nie ma nowych informacji."
        :voter-bound-mailed-explanation "Twoja karta do głosowania została nadana i jest w drodze do Ciebie. "
        :voter-bound-in-transit-explanation "Twoja karta do głosowania jest w poczcie, w drodze do Ciebie! "
        :voter-bound-delivered-explanation "Zgodnie z danymi USPS Twoja karta do głosowania powinna do Ciebie dotrzeć mniej więcej w %1. "
        :voter-bound-delivered-explanation-2 "Na podstawie danych USPS należy się spodziewać, że karta wyborcza dotrze na Pana/Pani adres mniej więcej w dniu %1. "
        :office-bound-mailed-explanation "Nadałeś(aś) swoją kartę do głosowania na poczcie. Jest w drodze do biura wyborczego."
        :office-bound-in-transit-explanation "Twoja karta do głosowania jest w poczcie, w drodze do biura wyborczego "
        :office-bound-delivered-explanation-on "Biuro wyborcze powinno było otrzymać Twoją kartę do głosowania %1. "
        :office-bound-delivered-explanation "Biuro wyborcze powinno było otrzymać Twoją kartę do głosowania. "
        :they-should-receive-it-by-eod "Powinieneś/powinnaś ją otrzymać do wieczora %1. "
        :if-there-are-problems "Jeżeli pojawią się problemy z Twoją kartą do głosowania, zostaniesz powiadomiony(a) przez członka komisji wyborczej."
        :vote! "Zagłosuj!"
        :vote-instructions "Aby oddać głos, należy postępować zgodnie z instrukcjami na karcie wyborczej i kopercie."
        :continue "Przejdź dalej"
        :subscribe "Subskrybuj"
        :unsubscribe "Anuluj subskrypcję"
        :you-have-signed-up-to-email-notys "Zarejestrował/-a się Pan/Pani, aby otrzymywać powiadomienia o wyborach za pośrednictwem poczty elektronicznej."
        :sorry! "Przepraszamy!"
        :could-not-verify-email "Nie mogliśmy zweryfikować Twojego adresu e-mail."
        :you-have-been-unsubscribed-from-email-notys "Zrezygnował/-a Pan/Pani z otrzymywania powiadomień o wyborach za pośrednictwem poczty elektronicznej."
        :error-processing-unsubcribe "Wystąpił błąd przy przetwarzaniu Twojej prośby o rezygnację z otrzymywania powiadomień."
        :loading-ellipses "Ładowanie..."
        :thank-you! "Dziękujemy!"
        :thanks-for-voting "Dziękujemy za oddanie głosu!"
        :learn-more "Dowiedz się więcej"
        :privacy "Prywatność"
        :terms "Warunki"}
   :ru {:endonym "Pусский"
        :missing "**ОТСУТСТВУЕТ**"
        :track-your-ballot "Отследить свой бюллетень"
        :select-language "Выбрать язык"
        :select-election "Выбрать выборы"
        :required-field "Обязательное поле"
        :name "Имя"
        :name-description "Имя, указанное в вашей карте регистрации избирателя"
        :your-name "Ваше имя"
        :first-name "Имя"
        :last-name "Фамилия"
        :address "Адрес"
        :address-description "Почтовый адрес, на который вы запрашивали отправку бюллетеня"
        :address-1-placeholder "Улица или абонентский ящик"
        :address-2-placeholder "Квартира, апартаменты, блок или дом"
        :ballot-address "Ваш почтовый адрес для отправки бюллетеня"
        :addr-line-1 "Адресная строка 1"
        :addr-line-2 "Адресная строка 2"
        :city "Город"
        :state "Штат"
        :select-state "Выбрать штат"
        :zip "Почтовый индекс"
        :yes-receive-notys "Да, я хочу получать уведомления по электронной почте или в текстовых сообщениях (SMS) о статусе моего бюллетеня."
        :submit "Поиск"
        :fields-invalid "Выделенное ниже поле с записью недействительно. Исправьте введенные данные и еще раз отправьте форму."
        :unable-locate-ballot "К сожалению, нам не удается отследить ваш бюллетень в настоящий момент. Пожалуйста, перепроверьте данные и повторно отправьте форму или попробуйте позже."
        :unable-locate-ballot-2 "Введенная вами информация не соответствует ни одному бюллетеню в нашей системе. Перепроверьте информацию и повторно отправьте форму или повторите попытку позже."
        :multiple-ballots-found "Мы обнаружили несколько возможных совпадений при вводе ваших данных - выберите правильные данные из предложенного списка."
        :ballot-located "Местонахождение вашего бюллетеня"
        :we-found-multiple-elections "Мы обнаружили бюллетени для голосования для нескольких видов выборов."
        :choose-an-election "Для более подробной информации выберите вид выборов."
        :partner-not-found "Партнер не найден"
        :searching-ellipse "Идет поиск..."
        :i-am "Я:"
        :none-of-the-above "Другой вариант"
        :search-usage-alttag "Инструкции по использованию интерфейса системы поиска"
        :logo-alt-tag "Компас Ballot Scout"
        :mailbox-error-alttag "Изображение почтового ящика с красным восклицательным знаком указывает на наличие проблем"
        :powered-by [[:span#powered-by "при поддержке"] [:span#democracy-works "%1"]]
        :footer-questions-call ["Возникли вопросы? Чтобы связаться с %1, позвоните по номеру: %2"]
        :call-office ["Позвонить в избирательную комиссию %1"]
        :email-office ["Отправить электронное письмо в избирательную комиссию %1"]
        :or-email [" или по электронной почте %1"]
        :notifications "Уведомления"
        :subscribe-me "Оформить подписку"
        :email-address "Электронный адрес"
        :phone-number "Номер телефона"
        :already-signed-up "Вы подписаны на уведомления %1."
        :unable-to-process "Нам не удалось обработать вашу подписку %1, попробуйте еще раз."
        :youve-subscribed "У вас оформлена подписка на уведомления через %1"
        :youre-subscribed "Подписка оформлена."
        :email "Электронный адрес"
        :sms "SMS-сообщение"
        :send-me-email "Отправлять мне уведомления по электронной почте"
        :send-me-sms "Отправлять мне уведомления в виде текстовых (СМС) сообщений"
        :check-email "Проверьте электронную почту, чтобы подтвердить подписку"
        :check-texts "Проверьте сообщения, чтобы подтвердить подписку"
        :update-email "Изменить адрес электронной почты"
        :update-phone "Изменить номер телефона"
        :you-have-been-unsubscribed "Ваша подписка отменена"
        :resubscribe "Для оформления повторной подписки отправьте «YES» на %1"
        :election "выборы"
        :Election "Выборы"
        :last-updated "Последнее обновление: %1"
        :it-was-last-scanned-in-city-state " Последнее сканирование - в %1, %2. "
        :it-was-last-scanned-usps " В последний раз было отсканировано USPS в %1, %2 %3"
        :not-tracked "Не отслеживается"
        :being-prepared "В процессе подготовки"
        :not-yet-mailed "Еще не отправлен"
        :mailed-to-voter "Отправлено вам"
        :out-for-delivery-to-voter "Отдан для отправки вам"
        :in-transit-to-voter "На пути к вам"
        :delivery-scheduled "Определена дата доставки"
        :mailed-to-office "Отправлено почтой в избирательную комиссию"
        :mailed-back-to-office "Отправлено обратно на избирательный участок"
        :in-transit-to-office "На пути в участок"
        :out-for-delivery-to-office "Отправлено в участок"
        :received "Получено"
        :received-by-office "Получено избирательной комиссией"
        :received-by-office-accepted "Получено избирательной комиссией. Принято"
        :received-by-office-flagged "Получено избирательной комиссией. Отмечено"
        :returned-to-sender "Возврат отправителю"
        :unable-to-deliver "Почтовой службе по какой-то причине не удалось доставить ваш бюллетень. Обратитесь в избирательный участок, воспользовавшись указанными ниже контактными данными."
        :unable-to-deliver-2 "Почта по какой-то причине не смогла доставить ваш бюллетень. "
        :learn-more-contact-office "Обратитесь в избирательную комиссию, чтобы уточнить детали."
        :ballot-accepted-on "Ваш бюллетень принят избирательным участком %1. "
        :issue-with-ballot "Возможно, с вашим бюллетенем возникла проблема. "
        :please-contact-office "Обратитесь в свой местный избирательный участок по адресу: "
        :not-tracked-explanation "Ваш бюллетень в данный момент не отслеживается. "
        :not-yet-mailed-explanation "Ваш бюллетень готовится к отправке. "
        :not-yet-mailed-explanation-2 "Ваш бюллетень еще не отправлен. Зайдите позже, чтобы получить обновленную информацию, или подпишитесь на автоматические уведомления."
        :check-back-soon " Регулярно проверяйте на наличие обновлений."
        :voter-bound-mailed-explanation "Ваш бюллетень отправлен и находится на пути к вам. "
        :voter-bound-in-transit-explanation "Ваш бюллетень отправлен вам почтой! "
        :voter-bound-delivered-explanation "На основе данных почтовой службы США ориентировочная дата доставки вашего бюллетеня: %1. "
        :voter-bound-delivered-explanation-2 "Согласно данным USPS, доставка бюллетеня по вашему адресу ожидается предположительно %1. "
        :office-bound-mailed-explanation "Вы вернули свой бюллетень в почтовое отделение, и его отправили обратно на избирательный участок."
        :office-bound-in-transit-explanation "Выполняется доставка вашего бюллетеня на избирательный участок. "
        :office-bound-delivered-explanation-on "Ваш бюллетень поступил на избирательный участок %1. "
        :office-bound-delivered-explanation "Ваш бюллетень получен избирательным участком. "
        :they-should-receive-it-by-eod "Его должны получить в конце дня в %1. "
        :if-there-are-problems "При возникновении проблем с вашим бюллетенем вас уведомят должностные лица, занимающиеся организацией выборов."
        :vote! "Голосуйте!"
        :vote-instructions "Чтобы проголосовать, следуйте инструкциям на бюллетене и конверте!"
        :continue "Продолжить"
        :subscribe "Подписывайся"
        :unsubscribe "Отписаться"
        :you-have-signed-up-to-email-notys "Вы оформили подписку на оповещения об отслеживании бюллетеня по электронной почте."
        :sorry! "Просим прощения!"
        :could-not-verify-email "Мы не можем проверить вашу электронную почту."
        :you-have-been-unsubscribed-from-email-notys "Ваша подписка на оповещения об отслеживании бюллетеня по электронной почте отменена."
        :error-processing-unsubcribe "При обработке вашего запроса об отмене подписки произошла ошибка."
        :loading-ellipses "Идет загрузка..."
        :thank-you! "Спасибо!"
        :thanks-for-voting "Благодарим за участие в голосовании!"
        :learn-more "Подробнее"
        :privacy "Конфиденциальность"
        :terms "Условия"}
   :sw {:endonym "Kiswahili"
        :missing "**INAKOSEKANA**"
        :track-your-ballot "Fuatilia Kura Yako"
        :select-language "Chagua Lugha"
        :select-election "Chagua Uchaguzi"
        :required-field "Sehemu Inayohitajika"
        :name "Jina"
        :name-description "Jina lililo katika usajili wako wa mpiga kura"
        :your-name "Jina Lako"
        :first-name "Jina la Kwanza"
        :last-name "Jina la Mwisho"
        :address "Anwani"
        :address-description "Anwani uliyoomba kura yako itumwe"
        :address-1-placeholder "Anwani ya mtaa au S.L.P."
        :address-2-placeholder "Fleti, Chumba, Chumba or Jengo"
        :ballot-address "Anwani Yako ya Kutuma Kura"
        :addr-line-1 "Anwani 1"
        :addr-line-2 "Anwani 2"
        :city "Jiji"
        :state "Jimbo"
        :select-state "Chagua Jimbo"
        :zip "Msimbo wa Eneo"
        :yes-receive-notys "Ndiyo, ningependa kupokea arifa za barua pepe au arafa (SMS) kuhusu hali ya kura yangu."
        :submit "Tafuta"
        :fields-invalid "Ingizo la sehemu iliyoangazishwa hapa chini si sahihi. Tafadhali sahihi ingizo na uwasilishe tena fomu."
        :unable-locate-ballot "Samahani, hatujaweza kupata kura yako wakati huu. Tafadhali kagua vizuri taarifa zako na uwasilishe upya fomu au ujaribu tena baadaye."
        :unable-locate-ballot-2 "Taarifa uliyoingiza haiwiani na kura zozote katika mfumo wetu. Tafadhali thibitisha taarifa yako kisha uwasilishe fomu upya ama ujaribu tena baadaye."
        :multiple-ballots-found "Tulipata uwezekano wa milingano mingi ya taarifa ulizoingiza - tafadhali chagua taarifa sahihi kutoka kwenye orodha iliyo hapa chini."
        :ballot-located "Kura Yako Imepatikana"
        :we-found-multiple-elections "Tumepata kura za chaguzi nyingi."
        :choose-an-election "Tafadhali chagua moja kati ya chaguzi zifuatazo kwa maelezo zaidi."
        :partner-not-found "Mshirika hapatikani"
        :searching-ellipse "Inatafuta..."
        :i-am "Mimi ni:"
        :none-of-the-above "Hamna kati ya zilizo hapo juu"
        :search-usage-alttag "Tafua maagizo ya matumizi ya wijeti"
        :logo-alt-tag "Nembo ya dira ya Ballot Scout"
        :mailbox-error-alttag "Picha ya kisanduku cha barua iliyo na alama nyekundu ya mshangao ili kuonyesha kuwa kuna tatizo."
        :powered-by [[:span#powered-by "inaendeshwa na"] [:span#democracy-works "%1"]]
        :footer-questions-call ["Una maswali? Ili kuwasiliana na %1, piga simu %2"]
        :call-office ["Piga Simu %1 Ofisi ya Uchaguzi"]
        :email-office ["Barua Pepe %1 Ofisi ya Uchaguzi"]
        :or-email [" au tuma barua pepe %1"]
        :notifications "Arifa"
        :subscribe-me "Nisajili"
        :email-address "Anwani ya barua pepe"
        :phone-number "Nambari ya simu"
        :already-signed-up "Tayari umejisajili kwa arifa za %1."
        :unable-to-process "Hatukuweza kuchakata usajili wako wa %1, tafadhali jaribu tena baadaye."
        :youve-subscribed "Umejisajili ili kupokea arifa kupitia %1"
        :youre-subscribed "Umejisajili."
        :email "Barua pepe"
        :sms "SMS"
        :send-me-email "Nitumie taarifa kwa barua pepe"
        :send-me-sms "Nitumie taarifa za ujumbe mfupi (SMS)"
        :check-email "Angalia barua pepe zako ili kuthibitisha usajili"
        :check-texts "Angalia jumbe zako ili kuthibitisha usajili"
        :update-email "Hakiki barua pepe"
        :update-phone "Hakiki nambari ya simu"
        :you-have-been-unsubscribed "Umeondolewa katika kufuatilia kura kupitia barua pepe"
        :resubscribe "Kwa kujisajili tena tuma ujumbe \"YES\" kwa %1"
        :election "uchaguzi"
        :Election "Uchaguzi"
        :last-updated "Mara ya mwisho kusasishwa: %1"
        :it-was-last-scanned-in-city-state " Mara ya mwisho ilichanganuliwa %1, %2. "
        :it-was-last-scanned-usps " Iliskaniwa mara ya mwisho na USPS katika %1, %2 mnamo %3"
        :not-tracked "Haifuatiliwi"
        :being-prepared "Inatayarishwa"
        :not-yet-mailed "Bado haijatumwa"
        :mailed-to-voter "Imetumwa kwako"
        :out-for-delivery-to-voter "Imetoka ili kuwasilishwa kwako"
        :in-transit-to-voter "Inasafiri kwako"
        :delivery-scheduled "Uwasilishaji umeratibiwa"
        :mailed-to-office "Imetumwa Ofisini"
        :mailed-back-to-office "Imetumwa tena kwenye ofisi"
        :in-transit-to-office "Inasafiri ofisini"
        :out-for-delivery-to-office "Imetoka ili kuwasilishwa kwenye ofisi"
        :received "Imepokelewa"
        :received-by-office "Imepokelewa na Ofisi"
        :received-by-office-accepted "Imepokelewa na Ofisi - Limekubaliwa"
        :received-by-office-flagged "Imepokelewa Ofisini – Imeripotiwa"
        :returned-to-sender "Imerejeshwa kwa mtumaji"
        :unable-to-deliver "Ofisi ya posta haikuweza kuwasilisha kura yako kwa sababu fulani. Tafadhali wasiliana na ofisi ya uchaguzi kwa kutumia maelezo ya mawasiliano yaliyo hapa chini."
        :unable-to-deliver-2 "Posta haingeweza kuwasilisha kura yako kwa sababu fulani. "
        :learn-more-contact-office "Ili kufahamu zaidi tafadhali wasiliana na ofisi ya uchaguzi."
        :ballot-accepted-on "Kura yako ilikubalika na ofisi ya uchaguzi %1. "
        :issue-with-ballot "Huenda kukawa na tatizo na kura yako. "
        :please-contact-office "Tafadhali wasiliana na ofisi yako ya karibu ya uchaguzi kwa "
        :not-tracked-explanation "Kura yako haifuatiliwi kwa sasa. "
        :not-yet-mailed-explanation "Kura yako inatayarishwa kwa ajili ya kutuma. "
        :not-yet-mailed-explanation-2 "Kura yako bado haijatumwa. Angalia tena baadaye kwa taarifa mpya au jisajili kwa arifa ili uendelee kupata taarifa kiotomatiki."
        :check-back-soon " Rudi baadaye kwa taarifa zilizosasishwa."
        :voter-bound-mailed-explanation "Kura yako imetumwa na iko njiani kuelekea kwako. "
        :voter-bound-in-transit-explanation "Kura yako iko kwenye barua kuelekea kwako! "
        :voter-bound-delivered-explanation "Kulingana na data ya USPS, unapaswa kutarajia kura yako kuwasili mnamo/takribani %1. "
        :voter-bound-delivered-explanation-2 "Kulingana na data za USPS, unapaswa kutarajia kura yako kufika katika anwani yako mnamo/karibu %1. "
        :office-bound-mailed-explanation "Umerejesha kura yako kwenye ofisi ya posta na inarejeshwa kwenye ofisi ya uchaguzi."
        :office-bound-in-transit-explanation "Kura yako inasafiri kupitia barua kuelekea kwenye ofisi ya uchaguzi. "
        :office-bound-delivered-explanation-on "Kura yako ilipaswa kuwa imepokelewa na ofisi ya uchaguzi mnamo %1. "
        :office-bound-delivered-explanation "Kura yako ilipaswa kuwa imepokelewa na ofisi ya uchaguzi. "
        :they-should-receive-it-by-eod "Wanapaswa kuipokea kufikia mwisho wa siku mnamo %1. "
        :if-there-are-problems "Ikiwa kuna matatizo kwenye kura yako, utaarifiwa na maafisa wa uchaguzi."
        :vote! "Piga kura! "
        :vote-instructions "Fuata maagizo katika kura na bahasha ili kupiga kura!"
        :continue "Endelea"
        :subscribe "Jisajili"
        :unsubscribe "Jiondoe"
        :you-have-signed-up-to-email-notys "Umefanikiwa kujisajili ili kupokea arifa za kufuatilia kura kupitia barua pepe."
        :sorry! "Samahani!"
        :could-not-verify-email "Hatukuweza kuthibitisha barua pepe yako."
        :you-have-been-unsubscribed-from-email-notys "Umeondolewa katika hatua ya kupokea arifa za kufuatilia kura kupitia barua pepe."
        :error-processing-unsubcribe "Kulikuwa na hitilafu katika kushughulikia ombi lako la kutaka uondolowe kwenye orodha."
        :loading-ellipses "Inapakia..."
        :thank-you! "Asante!"
        :thanks-for-voting "Asante kwa Kupiga Kura!"
        :learn-more "Pata Maelezo Zaidi"
        :privacy "Faragha"
        :terms "Masharti"}
   :tl {:endonym "Tagalog"
        :missing "***NAWAWALA***"
        :track-your-ballot "I-track ang Iyong Balota"
        :select-language "Pumili ng Wika"
        :select-election "Pumili ng Eleksyon"
        :required-field "Kinakailangang Impormasyon"
        :name "Pangalan"
        :name-description "Ang pangalang lumalabas sa inyong pagpaparehistro bilang botante"
        :your-name "Pangalan mo"
        :first-name "Pangalan"
        :last-name "Apelyido"
        :address "Address"
        :address-description "Ang address kung saan hiniling ninyong ipapadala ang balota ninyo"
        :address-1-placeholder "Street address o P.O. Box"
        :address-2-placeholder "Apt, Suite, Unit o Gusali"
        :ballot-address "Address sa Koreo para sa Iyong Balota"
        :addr-line-1 "Address line 1"
        :addr-line-2 "Address line 2"
        :city "Siyudad"
        :state "Estado"
        :select-state "Pumili ng Estado"
        :zip "Zip Code"
        :yes-receive-notys "Oo, gusto kong makatanggap ng mga notipikasyon sa email o text message (SMS) tungkol sa kalagayan ng aking balota."
        :submit "Hanapin"
        :fields-invalid "Hindi balido ang field entry na naka-highlight sa ibaba. Itama ang entry at i-submit muli ang form."
        :unable-locate-ballot "Sorry, hindi namin mahanap ang iyong balota sa oras na ito. I-check muli ang impormasyon at i-submit muli ang form o subukan muli mamaya."
        :unable-locate-ballot-2 "Ang impormasyong inilagay ninyo ay hindi tumutugma sa anumang balota sa system namin. Pakisuri nang mabuti ang inyong impormasyon at pakisumite ulit ang form o pakisubukang muli sa ibang pagkakataon."
        :multiple-ballots-found "Marami kaming nakitang potensyal na match sa impormasyong inilagay mo - pillin ang tamang impormasyon mula sa listahan sa ibaba."
        :ballot-located "Nakita na ang Iyong Balota"
        :we-found-multiple-elections "Marami kaming balotang nakita para sa iba't ibang eleksyon."
        :choose-an-election "Pumili ng isa sa mga sumusunod na eleksyon para sa mas maraming detalye."
        :partner-not-found "Hindi nakita ang partner"
        :searching-ellipse "Naghahanap..."
        :i-am "Ako si:"
        :none-of-the-above "Wala sa nabanggit"
        :search-usage-alttag "Hanapin ang mga tagubilin sa paggamit ng widget"
        :logo-alt-tag "Compass logo ng Ballot Scout"
        :mailbox-error-alttag "Larawan ng mailbox na may pulang tandang padamdam para ipahiwatig na may hindi tama"
        :powered-by [[:span#powered-by "pinapagana ng"] [:span#democracy-works "%1"]]
        :footer-questions-call ["May mga tanong? Para kontakin ang %1, tumawag sa %2"]
        :call-office ["Tawagan ang Tanggapan ng Eleksyon ng %1"]
        :email-office ["Mag-email sa Tanggapan ng Eleksyon ng %1"]
        :or-email [" o email %1"]
        :notifications "Mga Notipikasyon"
        :subscribe-me "I-subscribe Ako"
        :email-address "Email address"
        :phone-number "Numero ng telepono"
        :already-signed-up "Nakapag-sign up ka na para sa mga notipikasyon sa %1."
        :unable-to-process "Hindi namin naiproseso ang iyong suskripsyon sa %1, subukan muli mamaya."
        :youve-subscribed "Nag-subscribe ka sa mga notipikasyon sa %1"
        :youre-subscribed "Naka-subscribe ka na"
        :email "Email"
        :sms "SMS"
        :send-me-email "Magpadala sa akin ng mga update sa email"
        :send-me-sms "Magpadala sa akin ng mga update sa text message (SMS)"
        :check-email "Tingnan ang iyong mga email para makumpirma ang subscription"
        :check-texts "Tingnan ang iyong mga text para makumpirma ang subscription"
        :update-email "I-update ang email"
        :update-phone "I-update ang numero ng telepono"
        :you-have-been-unsubscribed "Na-unsubscribe ka na"
        :resubscribe "Para mag-subscribe ulit, i- text ang \"YES\" sa %1"
        :election "eleksyon"
        :Election "Eleksyon"
        :last-updated "Huling na-update: %1"
        :it-was-last-scanned-in-city-state " Huli itong nai-scan sa %1, %2. "
        :it-was-last-scanned-usps "Huli itong na-scan ng USPS sa %1, %2 noong %3"
        :not-tracked "Hindi natrack"
        :being-prepared "Pagiging Handa"
        :not-yet-mailed "Hindi pa naipadala sa koreo."
        :mailed-to-voter "Ipinadala na sa iyo sa koreo"
        :out-for-delivery-to-voter "Nakalabas na para i-deliver sa iyo"
        :in-transit-to-voter "Papunta sa iyo"
        :delivery-scheduled "Nakaiskedyul na ang pagdeliver"
        :mailed-to-office "Ipinadala sa Office"
        :mailed-back-to-office "Pinadala na sa koreo pabalik sa opisina"
        :in-transit-to-office "Papunta sa opisina"
        :out-for-delivery-to-office "Nakalabas na para i-deliver sa opisina"
        :received "Natanggap"
        :received-by-office "Natanggap ng Office"
        :received-by-office-accepted "Natanggap ng Office - Tinanggap"
        :received-by-office-flagged "Natanggap ng Office - Na- flag"
        :returned-to-sender "Ibinalik sa nagpadala"
        :unable-to-deliver "Sa anumang dahilan, hindi nadeliver ng post office ang iyong balota. Kontakin ang opisina ng eleksyon gamit ang mga detalye na nasa ibaba."
        :unable-to-deliver-2 "Hindi naihatid ng post office ang balota ninyo sa hindi alam na dahilan. "
        :learn-more-contact-office "Para alamin pa, paki- contact ang tanggapan ng eleksyon."
        :ballot-accepted-on "Tinanggap na ng opisina ng eleksyon ang iyong balota noong %1. "
        :issue-with-ballot "Maaaring may isyu sa iyong balota. "
        :please-contact-office "Kontakin ang iyong lokal na opisina ng eleksyon sa %1"
        :not-tracked-explanation "Kasalukuyang hindi na-tatrack ang iyong balota. "
        :not-yet-mailed-explanation "Inihahanda na ang iyong balota para ipadala sa koreo. "
        :not-yet-mailed-explanation-2 "Hindi pa naipapadala ang inyong balota. Tingnan ulit sa ibang pagkakataon para sa napapanahong impormasyon o mag-sign up para sa mga notipikasyon para manatiling updated nang awtomatiko."
        :check-back-soon " Mag-check ulit para sa mas updated na impormasyon."
        :voter-bound-mailed-explanation "Naipadala na sa koreo ang iyong balota at papunta na ito sa iyo. "
        :voter-bound-in-transit-explanation "Nasa koreo na ang iyong balota pabalik sa iyo! "
        :voter-bound-delivered-explanation "Base sa data ng USPS, maaari mong asahang dumating ang iyong balota sa/halos sa araw ng %1"
        :voter-bound-delivered-explanation-2 "Batay sa data ng USPS, dapat ninyong asahang makarating ang inyong balota sa inyong address sa/malapit sa %1. "
        :office-bound-mailed-explanation "Naibalik mo na ang iyong balota sa post office at ipinapadala na ito pabalik sa opisina ng eleksyon."
        :office-bound-in-transit-explanation "Nasa koreo na ang iyong balota pabalik sa opisina ng eleksyon. "
        :office-bound-delivered-explanation-on "Dapat nakuha na ng opisina ng eleksyon ang iyong balota noong %1. "
        :office-bound-delivered-explanation "Dapat nakuha na ng opisina ng eleksyon ang iyong balota. "
        :they-should-receive-it-by-eod "Dapat matanggap nila ito sa pagtatapos ng araw sa %1. "
        :if-there-are-problems "Kung may problema sa iyong balota, ipapaalam sa iyo ng mga opisyal sa eleksyon."
        :vote! "Bumoto!"
        :vote-instructions "Sundin ang mga alituntunin sa balota at sobre para makaboto!"
        :continue "Magpatuloy"
        :subscribe "Mag-subscribe"
        :unsubscribe "Mag-unsubscribe"
        :you-have-signed-up-to-email-notys "Matagumpay kang nakapag-sign up para makatanggap ng mga notification para sa pagsubaybay ng balota sa pamamagitan ng email."
        :sorry! "Pasensya"
        :could-not-verify-email "Hindi namin maberipika and iyong email."
        :you-have-been-unsubscribed-from-email-notys "Na-unsubscribe ka na mula sa mga notification para sa pagsubaybay ng balota sa pamamagitan ng email."
        :error-processing-unsubcribe "Nagkaroon ng pagkakamali sa pagpoproseso ng iyong kahilingang mag-unsubscribe."
        :loading-ellipses "Naglo-load..."
        :thank-you! "Salamat!"
        :thanks-for-voting "Salamat sa pagboto!"
        :learn-more "Alamin Pa"
        :privacy "Privacy"
        :terms "Mga Tuntunin"}})
